<template>
  <div class="analysis-weather-page col-block">
    <div class="map-container col-block">
      <div class="map-title-container">
        <div class="map-title">{{ '' + getCountryTitle() + ' 天氣觀測站點一覽' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div v-if="!stations || stations.length" class="map-main-container row-block">
        <div class="map-main-block row-block" :style="{ flex: 1, 'max-width': '1020px' }">
          <div class="gmap-container" :style="{ flex: 1, 'max-width': '600px', height: '400px' }">
            <googleMap
              v-if="stations"
              :countryName="countryName"
              :mapOption="{
                zoom: 4,
                zoomControl: false,
                streetViewControl: false,
                scaleControl: false,
                rotateControl: false,
                panControl: false,
                mapTypeControl: false,
                fullscreenControl: false
              }"
              :markerOptions="stations.map(station => ({
                position: { lat: station.latitude, lng: station.longitude },
                icon: require('../../assets/images/google-map-station-icon.svg')
              }))"
              @markerEvent="(event, marker, map) => markerEvent(event, marker, map)"
            ></googleMap>
          </div>
          <div><div :style="{ width: '20px' }"></div></div>
          <div class="map-info-container col-block" :style="{ width: '400px' }">
            <div class="info-table col-block">
              <div class="info-table-title row-block">觀測站點詳細資訊</div>
              <div v-if="curStation" class="info-table-content-container col-block">
                <div class="info-table-content row-block">
                  <div class="content-title row-block">
                    <div :style="{ flex: 1 }"></div>
                    <span>站點名稱</span>
                  </div>
                  <div class="content-content row-block">{{ curStation.name }}</div>
                </div>
                <div class="info-table-content row-block">
                  <div class="content-title row-block"> 
                    <div :style="{ flex: 1 }"></div>
                    <span>NOAA ID</span>
                  </div>
                  <div class="content-content row-block">
                    <a :href="'https://www.ncdc.noaa.gov/cdo-web/datasets/GHCND/stations/' + curStation.id + '/detail'" class="link" target="_blank">{{ curStation.id }}</a>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="info-table-content row-block">
                  <div class="content-title row-block">
                    <div :style="{ flex: 1 }"></div>
                    <span>經緯度</span>
                  </div>
                  <div class="content-content row-block">{{ Math.abs(curStation.latitude) + '° ' + (curStation.latitude >= 0 ? 'N' : 'S') + '，' + Math.abs(curStation.longitude) + '° ' + (curStation.longitude >= 0 ? 'E' : 'W') }}</div>
                </div>
                <div class="info-table-content row-block">
                  <div class="content-title row-block">
                    <div :style="{ flex: 1 }"></div>
                    <span>海拔高度</span>
                  </div>
                  <div class="content-content row-block">{{ curStation.elevation + ' ' + { MILLIMETERS: 'mm', CENTIMETERS: 'cm', METERS: 'm', KILOMETERS: 'km' }[curStation.elevationUnit] }}</div>
                </div>
              </div>
            </div>
            <div :style="{ height: '10px' }"></div>
            <div class="source-container row-block">
              <div :style="{ width: '15px' }"></div>
              <div class="source">資料來源：NOAA 美國國家海洋暨大氣總署</div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="map-title-container">
        <div class="map-title empty">{{ '沒有資料呈現，因為NOAA未收錄[' + getCountryTitle() + '] 2001~2020年 氣溫與雨量資料。' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
    <template v-if="!stations || stations.length">
      <hr>
      <div class="graph-container row-block stretch">
        <div class="options-container col-block" :style="{ width: '230px' }">
          <div :style="{ height: '15px' }"></div>
          <div class="option-tabs row-block">
            <div class="tab-container" :class="{ active: optionTab === 'graph' }" @click="e => optionTab = 'graph'">
              <div class="tab-block center-block">可調參數</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="sub-options-container" :style="{ flex: 1, height: 0 }">
            <div v-if="false" class="mask"></div>
            <div class="sub-options-block col-block" :class="[optionTab]">
              <div class="interval-container col-block">
                <div class="sub-option-title">統計圖區間</div>
                <div :style="{ height: '5px' }"></div>
                <div class="interval-block row-block">
                  <div class="interval center-block" :class="{ active: filterConditions.type === 'date' }" @click="e => switchType('date')">日資料</div>
                  <div class="hr"></div>
                  <div class="interval center-block" :class="{ active: filterConditions.type === 'month' }" @click="e => switchType('month')">月資料</div>
                </div>
              </div>
              <div :style="{ height: '20px' }"></div>
              <div class="time-container col-block">
                <div class="sub-option-title">日期起始與結束</div>
                <div :style="{ height: '5px' }"></div>
                <div class="time-block col-block input-group">
                  <input :type="filterConditions.type" :placeholder="'請選擇起始' + { date: '日', month: '月' }[filterConditions.type]" :max="startDefaultMax" :min="startDefaultMin" v-model="filterConditions.start">
                  <div :style="{ height: '5px' }"></div>
                  <input :type="filterConditions.type" :placeholder="'請選擇結束' + { date: '日', month: '月' }[filterConditions.type]" :max="endDefaultMax" :min="endDefaultMin" v-model="filterConditions.end">
                </div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <div class="description-container col-block">
                <div class="description-block col-block" v-html="[
                  '<span>日資料選取區間，最大選擇資料筆數為90日；月資料選取區間，最大選擇資料筆數為60個月。</span>',
                  '',
                  '<span>平台收集之數據為過去5年歷史資料，目前更新到' + dateFormat(new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', '')), 'yyyy/MM/dd') + '，若需即時數據，請拜訪<a class=\'link\' href=\'https://www.ncdc.noaa.gov/cdo-web/search\' target=\'_blank\'>NOAA</a>或其他氣候數據平台。</span>',
                ].join('<br>')"></div>
              </div>
              <div :style="{ height: '20px' }"></div>
              <div class="button-container col-block">
                <button type="button" name="button" class="main-button" @click="e => filterOnChange()">
                  <span>繪圖</span>
                </button>
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
        <div><div :style="{ width: '20px' }"></div></div>
        <div class="graph-chart-container col-blcok" :style="{ flex: 1, width: 0 }">
          <div class="graph-chart-field col-block" :style="{ height: '100%' }">
            <div class="option-container row-block">
              <div :style="{ flex: 1 }"></div>
              <div class="option-block row-block">
                <div class="option row-block input-group">
                  <div class="option-title">字體</div>
                  <div :style="{ width: '8.5px' }"></div>
                  <select v-model="fontSize">
                    <option value="14">小</option>
                    <option value="16">中</option>
                    <option value="20">大</option>
                  </select>
                </div>
              </div>
              <div :style="{ width: '15px' }"></div>
              <div class="button-block row-block">
                <button type="button" name="button" class="main-button option-button update" :disabled="false" @click="e => downloadData()">
                  <span>氣候數據下載</span>
                </button>
                <div :style="{ width: '15px' }"></div>
                <button type="button" name="button" class="main-button option-button update" :disabled="false" @click="e => downloadGraph()">
                  <span>另存圖檔</span>
                </button>
              </div>
            </div>
            <div :style="{ height: '10px' }"></div>
            <div class="graph-chart-block" :style="{ flex: 1 }">
              <div ref="chartField" class="chart-field" :style="{ '--chart-font-size': fontSize + 'px' }">
                <div v-if="(summarys && summarys.length) || (!graphConditions.start || !graphConditions.end)" class="chart-block col-block">
                  <div class="data-block col-block">
                    <div class="row-block">
                      <div :style="{ flex: 1 }"></div>
                      <div>
                        <b v-html="[
                          getCountryTitle() + ' ' + (curStation || {}).name + ' 之氣溫與降雨量統計圖',
                          getDateRange(true),
                        ].join('<br>')"></b>
                      </div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                    <div class="row-block">
                      <div :style="{ flex: 1 }"></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                  <div class="chart-block">
                    <vueCharts
                      v-if="state === 'station'"
                      ref="chart"
                      :options="chartOptions"
                      :autoresize="true"
                    ></vueCharts>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                  <div class="description-block row-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="col-block">
                      <div class="content">資料來源：NOAA 美國國家海洋暨大氣總署</div>
                      <div class="title">農業部農業試驗所</div>
                    </div>
                  </div>
                </div>
                <div v-else-if="summarys" class="chart-empty">{{ '沒有資料呈現，因為NOAA未收錄[' + (curStation || {}).name + ']\n' + getDateRange() + ' 氣溫與雨量資料' }}</div>
                <div v-else class="chart-empty">{{ '沒有資料呈現，因為NOAA未收錄[' + (curStation || {}).name + ']\n2001~2020年 氣溫與雨量資料' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import vueCharts from 'vue-echarts'
import echarts from 'echarts'
import 'echarts/lib/chart/bar'
import { mapGetters } from 'vuex'
import { getStations, getStationSummarys, postAccessLog } from '../../api'
import googleMap from '../tool/googleMap'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { html2DataUrl, downloadFile, dateFormat, sortData, toDivideNumber, isValidDate } from '../../constants/global/util'

export default {
  components: {
    vueCharts,
    googleMap
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: () => null
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      echarts: echarts,
      fontSize: '14',
      optionTab: 'graph',
      conditionCache: {
        date: null,
        month: null
      },
      filterConditions: {
        type: 'date',
        start: '',
        end: ''
      },
      graphConditions: {
        type: 'date',
        start: '',
        end: ''
      },
      today: new Date(),
      // stations
      stations: null,
      curStation: null,
      summarys: null
    }
  },
  computed: {
    ...mapGetters([
      'source'
    ]),
    analysisType () {
      return this.$route.name
    },
    countryName () {
      if (!this.country) {
        return ''
      }
      return { competitiveness: this.country.country_iso_name, attraction: this.country.partner_iso_name, toolcompetitiveness: this.country.country_iso_name, toolattraction: this.country.partner_iso_name }[this.analysisType]
    },
    startMin () {
      if (this.filterConditions.end) {
        let end = new Date(this.filterConditions.end)
        if (this.filterConditions.type === 'date') end.setDate(end.getDate() - 89)
        if (this.filterConditions.type === 'month') end.setMonth(end.getMonth() - 59)
        let format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type]
        return dateFormat(end, format)
      } else {
        return null
      }
    },
    endMax () {
      if (this.filterConditions.start) {
        let start = new Date(this.filterConditions.start)
        if (this.filterConditions.type === 'date') start.setDate(start.getDate() + 89)
        if (this.filterConditions.type === 'month') start.setMonth(start.getMonth() + 59)
        let format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type]
        return dateFormat(start, format)
      } else {
        return null
      }
    },
    startDefaultMax () {
      // let date = new Date((this.source['NOAA Daily Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let month = new Date((this.source['NOAA Monthly Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let result = date < month ? date : month
      let result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      let format = {
        date: 'yyyy-MM-dd',
        month: 'yyyy-MM'
      }[this.filterConditions.type]
      if (this.filterConditions.type === 'date') {
        result.setDate(result.getDate() - 1)
      } else if (this.filterConditions.type === 'month') {
        result.setMonth(result.getMonth() - 1)
      }
      return dateFormat(result, format)
    },
    startDefaultMin () {
      let result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      let minYear = result.getFullYear() - 5
      return {
        date: minYear + '-01-01',
        month: minYear + '-01'
      }[this.filterConditions.type]
    },
    endDefaultMax () {
      // let date = new Date((this.source['NOAA Daily Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let month = new Date((this.source['NOAA Monthly Summaries'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      // let result = date < month ? date : month
      let result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      let format = {
        date: 'yyyy-MM-dd',
        month: 'yyyy-MM'
      }[this.filterConditions.type]
      return dateFormat(result, format)
    },
    endDefaultMin () {
      let result = new Date((this.source['NOAA'] + '').replace(/(?!^)(?=(\d{2})+$)/g, '-').replace('-', ''))
      let minYear = result.getFullYear() - 5
      return {
        date: minYear + '-01-02',
        month: minYear + '-02'
      }[this.filterConditions.type]
    },
    // static
    chartOptions () {
      let summarys = sortData(this.summarys || [], 'date')
      let data = {
        date: [],
        tmin: [],
        tavg: [],
        tmax: [],
        prcp: []
      }
      let range = {
        temp: {
          max: Number.MIN_VALUE,
          min: Number.MAX_VALUE
        },
        prcp: {
          max: Number.MIN_VALUE,
          min: Number.MAX_VALUE
        }
      }
      const fixed = {
        date: 1,
        month: 2
      }[this.graphConditions.type]
      summarys.forEach(summary => {
        data.date.push(summary.date)
        data.tmin.push(summary.TMIN_value ? summary.TMIN_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null)
        data.tavg.push(summary.TAVG_value ? summary.TAVG_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null)
        data.tmax.push(summary.TMAX_value ? summary.TMAX_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null)
        data.prcp.push(summary.PRCP_value ? summary.PRCP_value.toFixed(fixed).replace(/0+$/, '').replace(/\.$/, '') : null)
        range.temp.max = Math.max(range.temp.max, summary.TMIN_value || Number.MIN_VALUE, summary.TAVG_value || Number.MIN_VALUE, summary.TMAX_value || Number.MIN_VALUE)
        range.temp.min = Math.min(range.temp.min, summary.TMIN_value || Number.MAX_VALUE, summary.TAVG_value || Number.MAX_VALUE, summary.TMAX_value || Number.MAX_VALUE)
        range.prcp.max = Math.max(range.prcp.max, summary.PRCP_value || Number.MIN_VALUE)
        range.prcp.min = Math.min(range.prcp.min, summary.PRCP_value || Number.MAX_VALUE, 0)
      })
      let prcpScale = {
        date: 2,
        month: 10
      }[this.graphConditions.type]
      let interval = (() => {
        let interval = toDivideNumber(toDivideNumber(Math.max(range.temp.max, range.prcp.max / prcpScale) - Math.min(range.temp.min, range.prcp.min / prcpScale), 7) / 7, 5)
        return summarys.length ? {
          temp: interval,
          prcp: interval * prcpScale
        } : {
          temp: 5,
          prcp: 5 * prcpScale
        }
      })()
      let yAxis = summarys.length ? {
        temp: {
          max: toDivideNumber(Math.max(range.temp.max, range.prcp.max / prcpScale), interval.temp),
          min: toDivideNumber(Math.min(range.temp.min, range.prcp.min / prcpScale, 0), interval.temp, true)
        },
        prcp: {
          max: toDivideNumber(Math.max(range.temp.max * prcpScale, range.prcp.max), interval.prcp),
          min: toDivideNumber(Math.min(range.temp.min * prcpScale, range.prcp.min), interval.prcp, true)
        }
      } : {
        temp: {
          max: 30,
          min: 0
        },
        prcp: {
          max: 30 * prcpScale,
          min: 0
        }
      }
      yAxis = {
        ...yAxis,
        prcp: {
          max: yAxis.prcp.max - yAxis.prcp.min,
          min: 0
        }
      }
      let symbolSize = summarys.length ? Math.min(450 / summarys.length, 13) : 1
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            },
            label: {
              fontSize: this.fontSize
            }
          },
          textStyle: {
            fontSize: this.fontSize
          }
        },
        color: [
          '#CC292E',
          '#999999',
          '#36A2DA',
          '#9CCECB'
        ],
        legend: {
          data: [
            '最高溫度',
            '平均温度',
            '最低溫度',
            '累積雨量'
          ],
          textStyle: {
            fontSize: this.fontSize
          }
        },
        xAxis: [
          {
            type: 'category',
            data: data.date,
            nameTextStyle: {
              fontSize: this.fontSize
            },
            axisLabel: {
              rotate: -45,
              fontSize: this.fontSize,
              formatter: value => {
                let format = {
                  date: 'yyyy-MM-dd',
                  month: 'yyyy-MM'
                }[this.graphConditions.type]
                return dateFormat(new Date(value), format)
              }
            },
            axisTick: {
              show: false
            },
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                color: '#9BC737',
                opacity: 0.1
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '雨量 (mm)',
            nameLocation: 'middle',
            nameGap: 50,
            nameTextStyle: {
              fontSize: this.fontSize
            },
            min: yAxis.prcp.min,
            max: yAxis.prcp.max,
            interval: interval.prcp,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}',
              fontSize: this.fontSize
            }
          },
          {
            type: 'value',
            name: '氣溫 (°C)',
            nameLocation: 'middle',
            nameGap: 50,
            nameTextStyle: {
              fontSize: this.fontSize
            },
            min: yAxis.temp.min,
            max: yAxis.temp.max,
            interval: interval.temp,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}',
              fontSize: this.fontSize
            }
          }
        ],
        grid: {
          top: 50,
          left: 100,
          right: 100,
          bottom: 100
        },
        series: [
          {
            name: '最高溫度',
            type: 'line',
            yAxisIndex: 1,
            symbol: 'circle',
            symbolSize: symbolSize,
            data: data.tmax
          },
          {
            name: '平均温度',
            type: 'line',
            yAxisIndex: 1,
            symbolSize: symbolSize,
            lineStyle: {
              type: 'dashed'
            },
            data: data.tavg
          },
          {
            name: '最低溫度',
            type: 'line',
            yAxisIndex: 1,
            symbol: 'circle',
            symbolSize: symbolSize,
            data: data.tmin
          },
          {
            name: '累積雨量',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: '80%',
            data: data.prcp
          }
        ]
      }
    },
    // global
    dateFormat () { return dateFormat }
  },
  watch: {
    'curStation' () {
      if (this.curStation) {
        this.getStationSummarys(!this.summarys)
      }
    },
    'filterConditions.start' () {
      if (this.filterConditions.start && isValidDate(new Date(this.filterConditions.start)) && new Date(this.filterConditions.start) >= new Date(this.startDefaultMin) && new Date(this.filterConditions.start) <= new Date(this.startDefaultMax)) {
        let start = this.filterConditions.start
        let end = this.filterConditions.end
        let startMin = new Date(start)
        let format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type]
        if (this.filterConditions.type === 'date') {
          startMin.setDate(startMin.getDate() + 1)
        } else if (this.filterConditions.type === 'month') {
          startMin.setMonth(startMin.getMonth() + 1)
        }
        startMin = dateFormat(startMin, format)
        this.filterConditions = {
          ...this.filterConditions,
          end: !end ? startMin : new Date(end) < new Date(start) ? startMin : new Date(end) > new Date(this.endMax) ? this.endMax : end
        }
      }
    },
    'filterConditions.end' () {
      if (this.filterConditions.end && isValidDate(new Date(this.filterConditions.end)) && new Date(this.filterConditions.end) >= new Date(this.endDefaultMin) && new Date(this.filterConditions.end) <= new Date(this.endDefaultMax)) {
        let start = this.filterConditions.start
        let end = this.filterConditions.end
        let endMax = new Date(end)
        let format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type]
        if (this.filterConditions.type === 'date') {
          endMax.setDate(endMax.getDate() - 1)
        } else if (this.filterConditions.type === 'month') {
          endMax.setMonth(endMax.getMonth() - 1)
        }
        endMax = dateFormat(endMax, format)
        this.filterConditions = {
          ...this.filterConditions,
          start: !start ? endMax : new Date(start) > new Date(end) ? endMax : new Date(start) < new Date(this.startMin) ? this.startMin : start
        }
      }
    }
  },
  methods: {
    async fetchData () {
      await this.fetchStations()
    },
    async fetchStations () {
      try {
        let config = this.$ls.get('userInfo')
        let country = { competitiveness: this.country.country_code, attraction: this.country.partner_code, toolcompetitiveness: this.country.country_code, toolattraction: this.country.partner_code }[this.analysisType]
        let response = await getStations(country, config)
        let stations = response.data
        this.stations = stations
        this.curStation = this.stations[0]
      } catch (error) {
        throw error
      }
    },
    async getStationSummarys (init = false) {
      if (init) {
        this.summarys = []
        return
      }
      try {
        let config = this.$ls.get('userInfo')
        let stationID = this.curStation.id
        let type = {
          date: 'daily_summaries',
          month: 'monthly_summaries'
        }[this.filterConditions.type]
        let format = {
          date: 'yyyy-MM-dd',
          month: 'yyyy-MM'
        }[this.filterConditions.type]
        let defautStart = new Date()
        let defaultEnd = new Date()
        defautStart.setDate(defautStart.getDate() - 30)
        let data = init ? {
          start_date: dateFormat(new Date(defautStart), format),
          end_date: dateFormat(new Date(defaultEnd), format)
        } : {
          start_date: this.filterConditions.start ? dateFormat(new Date(this.filterConditions.start), format) : null,
          end_date: this.filterConditions.end ? dateFormat(new Date(this.filterConditions.end), format) : null
        }
        let response = await getStationSummarys(stationID, type, data, config)
        let summarys = response.data
        if (summarys.length) {
          summarys = summarys.reduce((s, c) => ({ ...s, [c.date]: c }), {})
          let start = new Date(data.start_date)
          while (true) {
            let key = dateFormat(start, format)
            summarys[key] = summarys[key] || { date: key }
            if (this.filterConditions.type === 'date') start.setDate(start.getDate() + 1)
            if (this.filterConditions.type === 'month') start.setMonth(start.getMonth() + 1)
            if (key === data.end_date) {
              break
            }
          }
        }
        this.summarys = Object.values(summarys)
        return true
      } catch (error) {
        // this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    getFilterTitle (value) {
      if (!this.conditions.filters[value]) {
        return ''
      }
      return this.filterOptions.filters.find(filter => filter.value === value).options.find(option => option.value === this.conditions.filters[value]).title
    },
    getCountryTitle () {
      if (!this.country) {
        return ''
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType]
    },
    getDateRange (isHtml = false) {
      if (this.graphConditions.start && this.graphConditions.end) {
        let defautStart = new Date()
        let defaultEnd = new Date()
        defautStart.setDate(defautStart.getDate() - 30)
        let format = {
          date: 'yyyy年 MM月 dd日',
          month: 'yyyy年 MM月'
        }[this.graphConditions.type]
        let start = this.graphConditions.start || defautStart
        let end = this.graphConditions.end || defaultEnd
        return dateFormat(new Date(start), format) + ' ~ ' + dateFormat(new Date(end), format)
      } else {
        return isHtml ? '<span style="opacity:0;">_</span>' : ''
      }
    },
    async downloadGraph () {
      let url = await html2DataUrl(this.$refs.chartField, 'png', 0.3)
      let title = ''
      title = this.getCountryTitle() + ' ' + (this.curStation || {}).name + ' ' + this.getDateRange().replace(/ /g, '') + ' 之氣溫與降雨量統計圖'
      // await this.sendGraphAccessLog()
      downloadFile(title, url, '_blank')
    },
    async downloadData () {
      let csvContents = []
      let extraContents = []
      extraContents.push(this.getCountryTitle() + ' ' + (this.curStation || {}).name + '之氣溫與降雨量資料表, 資料來源：NOAA 美國國家海洋暨大氣總署')
      extraContents = [extraContents.join(', ')]
      csvContents.push(extraContents)
      let headerContents = [
        {
          date: '日期',
          month: '月'
        }[this.filterConditions.type],
        '最高溫度(°C)',
        '平均溫度(°C)',
        '最低溫度(°C)',
        '累積雨量(mm)'
      ]
      csvContents.push(headerContents)
      for (let data of this.summarys) {
        let contents = [
          data.date,
          data.TMAX_value,
          data.TAVG_value,
          data.TMIN_value,
          data.PRCP_value
        ]
        csvContents.push(contents)
      }
      let url = 'data:application/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContents.map(x => '"' + x.join('","') + '"').join('\r\n') + '\r\n')
      let title = ''
      title = this.getCountryTitle() + ' ' + (this.curStation || {}).name + ' ' + this.getDateRange().replace(/ /g, '') + ' 之氣候數據.csv'
      // await this.sendTableAccessLog()
      downloadFile(title, url, '_target')
    },
    async sendGraphAccessLog () {
      try {
        let config = this.$ls.get('userInfo')
        const accessFileType = 'station'
        let type = {
          country: {
            competitiveness: 'market_competitiveness',
            attraction: 'market_attractiveness',
            toolcompetitiveness: 'market_competitiveness',
            toolattraction: 'market_attractiveness'
          },
          year: {
            competitiveness: 'single_country_market_competitiveness',
            attraction: 'single_country_market_attractiveness',
            toolcompetitiveness: 'single_country_market_competitiveness',
            toolattraction: 'single_country_market_attractiveness'
          }
        }[this.dataType][this.analysisType]
        let paramDatas = {
          country: this.dataType === 'country' ? {
            competitiveness: {
              access_file_type: accessFileType,
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            attraction: {
              access_file_type: accessFileType,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: accessFileType,
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolattraction: {
              access_file_type: accessFileType,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            }
          } : {},
          year: this.dataType === 'year' ? {
            competitiveness: {
              access_file_type: accessFileType,
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            attraction: {
              access_file_type: accessFileType,
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: accessFileType,
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            toolattraction: {
              access_file_type: accessFileType,
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            }
          } : {}
        }[this.dataType][this.analysisType]
        let data = {
          ...paramDatas
        }
        await postAccessLog(type, data, config)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async filterOnChange () {
      if (this.filterConditions.start && isValidDate(new Date(this.filterConditions.start)) && this.filterConditions.end && isValidDate(new Date(this.filterConditions.end))) {
        if (this.filterConditions.type === 'date') {
          let start = new Date(this.filterConditions.start)
          start = start < new Date(this.startDefaultMin) ? new Date(this.startDefaultMin) : start > new Date(this.startDefaultMax) ? new Date(this.startDefaultMax) : start
          this.filterConditions.start = dateFormat(start, 'yyyy-MM-dd')
          let end = new Date(this.filterConditions.end)
          end = end < new Date(this.endDefaultMin) ? new Date(this.endDefaultMin) : end > new Date(this.endDefaultMax) ? new Date(this.endDefaultMax) : end
          this.filterConditions.end = dateFormat(end, 'yyyy-MM-dd')
          start.setDate(start.getDate() + 90)
          if (start <= end) {
            this.addToast('error', '您選擇的日期區間超過90日，請縮小範圍。')
          } else {
            if (await this.getStationSummarys()) {
              this.conditionCache['date'] = { ...this.filterConditions }
              this.graphConditions = { ...this.filterConditions }
            }
          }
        } else if (this.filterConditions.type === 'month') {
          let start = new Date(this.filterConditions.start)
          start = start < new Date(this.startDefaultMin) ? new Date(this.startDefaultMin) : start > new Date(this.startDefaultMax) ? new Date(this.startDefaultMax) : start
          this.filterConditions.start = dateFormat(start, 'yyyy-MM')
          let end = new Date(this.filterConditions.end)
          end = end < new Date(this.endDefaultMin) ? new Date(this.endDefaultMin) : end > new Date(this.endDefaultMax) ? new Date(this.endDefaultMax) : end
          this.filterConditions.end = dateFormat(end, 'yyyy-MM')
          start.setMonth(start.getMonth() + 60)
          if (start <= end) {
            this.addToast('error', '您選擇的月區間超過60個月，請縮小範圍。')
          } else {
            if (await this.getStationSummarys()) {
              this.conditionCache['month'] = { ...this.filterConditions }
              this.graphConditions = { ...this.filterConditions }
            }
          }
        }
      }
    },
    async switchType (type) {
      let cache = this.conditionCache[type] || {}
      this.filterConditions = {
        type: type,
        start: cache.start || '',
        end: cache.end || ''
      }
      if (cache.type) {
        await this.filterOnChange()
      }
    },
    // google map
    markerEvent (event, marker, map) {
      if (event === 'click') {
        const position = marker.getPosition()
        let station = this.stations.find(station => station.latitude === position.lat() && station.longitude === position.lng())
        this.curStation = station || this.curStation
        map.setCenter(map.getCenter())
        map.setZoom(map.getZoom())
      }
    }
  }
}
</script>

<style>
.echarts {
  width: 100% !important;
  height: 600px !important;
  min-height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/weather.vue